import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const ConfirmSoftphoneModalExit = () => {
  const { t } = useTranslation('phone', { keyPrefix: 'create-new-softphone' });

  return (
    <>
      <Text
        as='div'
        css={css`
          margin-bottom: ${theme.spacing(5)};
        `}
      >
        {t(
          'Your progress will not be saved if you leave the setup now. A softphone will not be created for this user until this setup is completed.'
        )}
      </Text>
      <Text
        weight='bold'
        css={css`
          margin-bottom: ${theme.spacing(4.5)};
        `}
      >
        {t('Are you sure you want to quit setting up this softphone?')}
      </Text>
    </>
  );
};
